import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";
import { Field, formValueSelector, reduxForm, change } from "redux-form";
import ChipsGrid from "components/ChipsGrid";
import validate from "./../validate";
import ImageResolver from "./../../ImageResolver.js";
import { addPreviousPreviews } from "./../../../actions";
import SwitchInput from "../../../components/SwitchInput";
import ThemeButton from "../../../components/ThemeButton";
import SeparatingLine from "../../../components/SeparatingLine";
import FormHeader from "../../../components/FormHeader";
import FormWrapper from "../../FormWrapper";
import { getAllDoorColours } from "../../../selectors";
import utils from '../../../utils';
import { updatePreviousSelection } from '../../../actions';

const getBestMatch = (hardwares, selectedColour) => {
    let bestGuessMatch = selectedColour.bestGuessMatch;
    let hardwareIndex = 0;
    if (bestGuessMatch) {
        hardwareIndex = hardwares.findIndex(h => h.name.indexOf(bestGuessMatch) !== -1);
    }
    var hardwareId = hardwares[hardwareIndex] ? hardwares[hardwareIndex].id : hardwares[0].id;
    return hardwareId;
};

const SelectHardware = ({ input, colours, label }) => {
    return (
        <div style={{ paddingTop: 10 }}>
            <SwitchInput input={input}>{label}</SwitchInput>
            <ChipsGrid
                chipsPerRow={6}
                colours={colours}
                selectedId={input.value}
                onChange={input.onChange}
            />
        </div>
    );
};

class HardwareForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DoorLetterboxId: null
        };
    }

    onFieldChange(name, emptyValue, addPreviousPreview, e, value, oldValue) {
        // if the value is true, the Switch has been re-enabled, so grab the value from State
        if (value === true) {
            value = this.state[name];

            // if the value is empty and the old value isn't "true", it means we've disaled the Switch. Store the old value (selected swatch) in State
        } else if (value === false && oldValue !== true) {
            var newState = {};
            newState[name] = oldValue;
            this.setState(newState);
        }

        // if we have a value, update the previews
        if (value) {
            addPreviousPreview(value);

            // if we don't have a value, update the preview with the empty value
        } else {
            addPreviousPreview(emptyValue);
        }

        // dispatch the change
        setTimeout(() => this.props.dispatch(change("DoorWizard", name, value)), 1);
    }

    componentDidMount() {
        let { letterboxes, selectedLetterbox, selectedColour, dispatch, previousSelection } = this.props;

        if (!selectedLetterbox.id) {
            if (letterboxes.length > 0) {
                var letterboxId = utils.findHardwareByColour(letterboxes, previousSelection.DoorPvcHandleColour) || getBestMatch(letterboxes, selectedColour);
                dispatch(change("DoorWizard", "DoorLetterboxId", letterboxId));
            }
        }
    }

    onSubmit(values) {
        this.props.onSubmit(values);
    }

    render() {
        return (
            <form className="HardwareForm" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader
                    title={"Hardware"}
                    subtitle={"Add your accessories to match your handle."}
                />
                <SeparatingLine />

                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column pushOnLarge={7} large={5} className="preview-container">
                            <ImageResolver
                                query={{ productId: this.props.doorTypeId, extragroupid: 20 }}
                                filters={[{ extraId: this.props.selectedLetterbox.id }]}
                            />
                        </Column>
                        <Column className={"swatch-selector-container"} pullOnLarge={6} large={6}>
                            {this.props.showDoorLetterboxChoice && (
                                <Row isColumn>
                                    <Field
                                        name="DoorLetterboxId"
                                        component={SelectHardware}
                                        colours={this.props.letterboxes}
                                        onChange={this.onFieldChange.bind(
                                            this,
                                            "DoorLetterboxId",
                                            null,
                                            val =>
                                                this.props.addPreviousPreviews({ extraId: val }, [
                                                    6
                                                ])
                                        )}
                                        label="Include a letterbox"
                                    />
                                </Row>
                            )}
                        </Column>
                    </Row>
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorLetterboxId = valueSelector(state, "DoorLetterboxId");
    let doorTypeId = valueSelector(state, "DoorTypeId") || 7;
    let doorColourId = valueSelector(state, "DoorColourId");
    let doorColourInterior = valueSelector(state, "DoorColourInterior");

    let letterboxes = state.Door.Options.extras.filter(e => /letterbox/i.test(e.extraGroupName));
    letterboxes.sort(utils.sortExtraByRank);

    let noLetterbox = letterboxes.filter(e => /\bno\b/i.test(e.name))[0] || {};

    let selectedLetterbox = {};

    if (doorLetterboxId)
        selectedLetterbox = letterboxes.filter(c => c.id === doorLetterboxId)[0] || {};

    letterboxes = letterboxes.filter(e => !/\bno\b/i.test(e.name));

    let colours = getAllDoorColours(state);

    let selectedColour = colours.filter(c => c.id === doorColourId)[0];
    if (doorColourInterior && selectedColour.relatedColourId) {
        selectedColour = colours.filter(c => c.id === selectedColour.relatedColourId)[0];
    }

    return {
        selectedColour,
        letterboxes,
        selectedLetterbox,
        noLetterbox,
        doorTypeId,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { addPreviousPreviews, updatePreviousSelection })(
    reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate,
        initialValues: {
            // DoorKnocker: true,
            // DoorLetterbox: true
        }
    })(HardwareForm)
);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/uPVC/HardwareForm.js